<div *ngIf="project$ | async as project" class="container-fluid py-4">
  <div class="py-4">
    <app-breadcrumb-navigation
      [showPreviousPage]="isNavigable$ | async"
      [link]="LINK_PROJECTS_LIST"
      [dataTestId]="'projects-link'"
      [pageToNavigateTitle]="'PROFILE_NAVIGATION_PROJECTS'"
      [pageTitle]="project.title"
      [status]="(isExpired$ | async) ? EXPIRED : EMPTY"
    ></app-breadcrumb-navigation>
  </div>
  <div class="mb-4">
    <button
      *ngIf="project.permissions.invite_users"
      class="btn btn-primary me-3"
      type="button"
      data-test-id="btn-project-invite"
      (click)="inviteToProject()"
      [disabled]="isExpired$ | async"
    >
      {{ 'BTN_INVITE_TO_PROJECT' | translate }}
    </button>
    <button
      *ngIf="project.permissions.extend"
      class="btn btn-outline-primary me-3"
      type="button"
      data-test-id="btn-project-manage"
      [routerLink]="[LINK_PROJECTS_MANAGE, project.entity_id]"
    >
      {{ 'BTN_MANAGE_PROJECT' | translate }}
    </button>
    <button
      *ngIf="project.permissions.leave"
      class="btn btn-outline-primary me-3"
      type="button"
      data-test-id="btn-project-leave"
      (click)="leaveProject()"
      [disabled]="isExpired$ | async"
    >
      {{ 'BTN_LEAVE_PROJECT' | translate }}
    </button>
    <button
      *ngIf="project.permissions.request_to_join"
      appLongOperation
      class="btn btn-primary me-3"
      type="button"
      data-test-id="btn-project-join"
      (click)="joinProject()"
      [disabled]="isExpired$ | async"
    >
      {{ 'BTN_REQUEST_TO_JOIN_PROJECT' | translate }}
    </button>
  </div>

  <div *ngIf="counters$ | async as counters" class="tab-holder">
    <ul ngbNav #nav="ngbNav" (navChange)="onTabClick($event)" class="nav-tabs">
      <li ngbNavItem="project_info">
        <a ngbNavLink [attr.data-test-id]="'project_info'">
          {{ 'PROJECT_TAB_INFO' | translate }}
        </a>

        <ng-template ngbTabTitle> </ng-template>
        <ng-template ngbNavContent>
          <div class="info-project-holder">
            <app-project-info [entity]="project"></app-project-info>
          </div>

          <app-carousel
            *ngIf="project.linked_projects?.length"
            [data]="project.linked_projects"
            [type]="CardType.PROJECT"
            [title]="'LINKED_PROJECTS_TITLE'"
          >
          </app-carousel>

          <ng-container *ngIf="isSuggestedProjectsLoading">
            <div class="spinner-grow text-primary m-5" role="status" data-test-id="suggested-projects-loading-spinner">
              <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
            </div>
          </ng-container>

          <app-carousel
            *ngIf="suggestedProjects.length"
            [data]="suggestedProjects"
            [type]="CardType.PROJECT"
            [title]="'SUGGESTED_PROJECTS_TITLE'"
          >
          </app-carousel>
        </ng-template>
      </li>

      <li ngbNavItem="project_members">
        <a ngbNavLink [attr.data-test-id]="'project_members'">
          {{ 'PROJECT_TAB_MEMBERS' | translate }} ({{ counters.members_count }})
        </a>

        <ng-template ngbNavContent>
          <app-spinner>
            <app-table-users-list
              [tableConstructorData]="membersTable$ | async"
              [noUsersHint]="'NO_PROJECT_MEMBERS_TEXT'"
              [isExpired]="isExpired$ | async"
              (action)="onRemoveMember($event)"
            ></app-table-users-list>

            <div class="mt-1" *ngIf="membersTotalCount > pageSize">
              <ngb-pagination
                class="w-100 d-flex justify-content-center pagination custom-pagination"
                data-test-id="sent-requests-pagination-box"
                [collectionSize]="membersTotalCount"
                [(page)]="membersPageNumber"
                [maxSize]="3"
                [pageSize]="pageSize"
                [rotate]="true"
                (pageChange)="onMembersPageChanged($event)"
              ></ngb-pagination>
            </div>
          </app-spinner>
        </ng-template>
      </li>

      <ng-container *ngIf="project.permissions.view_posts">
        <li ngbNavItem="project_posts">
          <a ngbNavLink [attr.data-test-id]="'project_posts'">
            {{ 'PROJECT_TAB_POSTS' | translate }} ({{ counters.posts_count }})
          </a>

          <ng-template ngbNavContent>
            <app-spinner>
              <app-items-list
                [items]="posts"
                [type]="CardType.POST"
                [searchState]="resolver.state"
                [itemsListContent]="content$ | async"
                [noItemsTitle]="'PROJECT_NO_POSTS'"
                (pageChanged)="resolver.onPageChanged($event)"
                [isExpired]="isExpired$ | async"
              ></app-items-list>
            </app-spinner>
          </ng-template>
        </li>
      </ng-container>
    </ul>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
